import { Button } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';

import TableRender, { RenderBoolean, TableRenderFieldT } from 'shared/components/Table/TableRender';
import { FlowT } from 'shared/models/flows';
import api from 'utils/api';

import './Flows.scss';

function Flows() {
  const history = useHistory();

  const goToID = (id: string) => {
    history.push(`/flows/${id}`);
  };

  const fields: TableRenderFieldT[] = [
    {
      displayName: 'Name',
      renderFn: (row: FlowT) => row.name,
    },
    {
      displayName: 'Source',
      renderFn: (row: FlowT) => row.sourceName,
      linkFn: (row: FlowT) => `/sources/${row.sourceId}`,
      align: 'center',
    },
    {
      displayName: 'IP Network',
      renderFn: (row: FlowT) => row.poolName,
      linkFn: (row: FlowT) => `/ip-networks/${row.poolId}`,
      align: 'center',
    },
    {
      displayName: 'Nb Devices',
      renderFn: (row: FlowT) => row.nbDeviceConfigs,
      align: 'center',
    },
    {
      displayName: 'Nb Device Profiles',
      renderFn: (row: FlowT) => row.nbDeviceProfiles,
      align: 'center',
    },
    {
      displayName: 'Sync Enable',
      renderFn: (row: FlowT) => RenderBoolean(row.enableSync, 'icon'),
      align: 'center',
    },
    {
      displayName: 'DTLS Enable',
      renderFn: (row: FlowT) => RenderBoolean(row.enableDtls, 'icon'),
      align: 'center',
    },
  ];

  return (
    <div>
      <div className="title__header">
        <h1>Flows</h1>
        <Link to="/flows/create">
          <Button variant="contained" color="secondary">Create</Button>
        </Link>
      </div>
      <TableRender
        api={api.flows}
        renderFields={fields}
        onClickRow={(row: any) => goToID(row.id)}
      />
    </div>
  );
}

export default Flows;
